ux-iws-sf-page-header {
    display: block;
    width: 100%;
    box-sizing: border-box;

    .ux-iws-header:not(.ux-iws-header--active) .ux-iws-header__main-wrapper {
        border-bottom-color: transparent;
    }

    .ux-iws-header__main-wrapper::after {
        content: "";
        display: block;
        position: absolute;
        pointer-events: none;
        top: 100%;
        left: 0;
        width: 100%;
        height: 20px;
        background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.08) 0%,
            rgba(0, 0, 0, 0.02) 50%,
            rgba(0, 0, 0, 0) 100%
        );
    }
}
